import { SESSION_BASED_EXPIRY_TIME } from './libs/constants'
import { setCookie } from './libs/utils/cookies'
import { hasAllPropertiesValid } from './libs/utils/object'
import { getInfoFromUrl } from './libs/utils/punchoutHandler'

const getPunchoutData = () => {
  const { pathname, href } = globalThis.location

  // Early exit if not punchout or is technical-login
  if (!pathname.includes('punchout') || pathname.includes('technical-login')) {
    return {}
  }

  const punchoutTypes = ['oci', 'procurement']
  const pathParts = href.split('/')

  const punchoutType = punchoutTypes.find((type) => pathParts.includes(type))

  const queryKeys = ['accessKey', 'secret', 'HOOK_URL', 'sessionId', 'type']
  if (punchoutType === 'oci') {
    const [encodedSecrets, queryString] = pathParts.at(-1).split('?')
    try {
      let decodedSecrets: string
      try {
        decodedSecrets = globalThis.atob(encodedSecrets)
      } catch {
        // Fallback: remove first character if it's not valid base64
        decodedSecrets = globalThis.atob(encodedSecrets.slice(1))
      }
      const fullQueryString = queryString ? `${decodedSecrets}&${queryString}` : decodedSecrets
      return getInfoFromUrl(fullQueryString, queryKeys, { type: punchoutType })
    } catch (error) {
      console.error('Error decoding OCI secrets:', error)
      return {}
    }
  }

  const decodedQueryString = globalThis.atob(pathParts.at(-1))
  const [, queryString] = decodedQueryString.split('?')
  return getInfoFromUrl(queryString, queryKeys, {
    type: 'cxml',
  })
}

export const handlePunchout = () => {
  const punchoutData = getPunchoutData()

  if (hasAllPropertiesValid(punchoutData)) {
    const { accessKey, secret, type } = punchoutData
    const expiredTime = Date.now() + SESSION_BASED_EXPIRY_TIME

    const commonCookieOptions = { expires: expiredTime }

    if (type === 'oci') {
      setCookie({
        name: 'HOOK_URL',
        value: punchoutData.HOOK_URL ? decodeURIComponent(punchoutData.HOOK_URL) : '',
        ...commonCookieOptions,
      })
    } else {
      const procurementCookieOptions = {
        ...commonCookieOptions,
        sameSite: 'None',
        secure: true,
      }

      setCookie({
        name: 'PUNCHOUT_SESSION_ID',
        value: punchoutData.sessionId ? decodeURIComponent(punchoutData.sessionId) : '',
        ...procurementCookieOptions,
      })

      setCookie({
        name: 'PUNCHOUT_TEMPLATE_TYPE',
        value: punchoutData.type ? decodeURIComponent(punchoutData.type) : '',
        ...procurementCookieOptions,
      })
    }

    const credentialString = `username=${accessKey}&password=${secret}`
    const encodedCredential = globalThis.btoa(credentialString)

    globalThis.location.replace(
      `/technical-login/${type}/${encodedCredential[0]}${encodedCredential}`,
    )
  }
}
